import { useRegistrationHandlers } from '~/domain/events/handlers/useRegistrationHandlers';
import { useRoiHandlers } from '~/domain/events/handlers/useRoiHandlers';
import { useStructureSetHandlers } from '~/domain/events/handlers/useStructureSetHandlers';
import { useWindowingHandlers } from '~/domain/events/handlers/useWindowingHandlers';

export function useDomainEventHandlers() {
    useRegistrationHandlers();
    useRoiHandlers();
    useStructureSetHandlers();
    useWindowingHandlers();
}
